const axios = require('axios');
const assert = require('assert');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class EmployeeServiceConnector {
  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async createEmployee(options = {}) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/employees`,
        method: 'POST',
        ...options,
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async updateEmployee(id, employee) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/employees/${id}`,
        method: 'PATCH',
        data: {
          ...employee,
        },
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async deleteEmployee({ id }, options = {}) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/employees/${id}`,
        method: 'DELETE',
        ...options,
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async listEmployees(params) {
    try {
      const { data, headers } = await this.httpClient.get(`/${CURRENT_VERSION}/employees`, {
        params,
      });
      return { data, headers };
    } catch (error) {
      return this._handleError(error);
    }
  }

  async findUsers(params) {
    try {
      const { data, headers } = await this.httpClient.get(`/${CURRENT_VERSION}/find-users`, { params });
      return { data, headers };
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getTravelRestrictionAssociationsCount({ travelRestrictionId }) {
    assert(travelRestrictionId, 'travelRestrictionId is required');
    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/travel-restriction-associations/count`, { params: { travelRestrictionId } });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async resendOnboardingEmail({ id, corporationId }) {
    assert(id, 'travelRestrictionId is required');
    try {
      const { data } = await this.httpClient.post(`/${CURRENT_VERSION}/employees/${id}/onboarding`, { corporationId });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  EmployeeServiceConnector,
};
